import { TextField, IconButton, InputAdornment } from '@mui/material'
import { styled } from '@mui/material/styles';
import { Controller } from 'react-hook-form'
import { IconX, IconCloudUpload } from '@tabler/icons-react'

import CustomTextField from './customTextField'

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function ControlledFilePicker({
  label,
  name,
  control = null,
  disabled = false,
  readOnly = false,
  variant = "outlined",
  size = "small",
  rules = null
}) {
  return (
    <Controller
      name={name}
      disabled={disabled}
      control={control}
      rules={rules}
      defaultValue=""
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <TextField
          label={label}
          placeholder={"No File Chosen"}
          variant={variant}
          size={size}
          fullWidth
          error={error}
          helperText={error ? error.message : ""}
          value={value ? value.name : ""}
          slotProps={{
            input: {
              readOnly: true,
              endAdornment: 
              (
                <InputAdornment position="end">
                  <IconButton
                    component="label"
                    color="primary"
                    aria-label="upload files"
                    tabIndex={-1}
                    edge="end"
                    disabled={readOnly || disabled}
                  >
                    <IconCloudUpload color="#757575" />
                    <VisuallyHiddenInput
                      type="file"
                      onChange={(event) => {
                        // console.log(event.target.files[0])
                        onChange(event.target.files[0])
                      }
                      }
                    />
                  </IconButton>
                </InputAdornment>
              )
              ,
            },
            inputLabel: {
              shrink: true,
              
            },
          }}
        />
      )}
    />
  )
}
